import { CsEnVyznam, CsEnPopis } from "b2b/renderers";

export const name = () => ({
  id: "name",
  label: "b2b.zdroje-grid-columns.typ.name.label",
  path: "name"
});
export const vyznam = () => ({
  id: "vyznam",
  label: "b2b.zdroje-grid-columns.typ.vyznam.label",
  path: "",
  renderer: CsEnVyznam
});
export const popis = () => ({
  id: "popis",
  label: "b2b.zdroje-grid-columns.typ.popis.label",
  path: "",
  renderer: CsEnPopis
});
